/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  ActivateSeededBuilderRequest,
  ActivateSeededBuilderResponse,
  AdminBuildersSearchGetV2Params,
  BadRequestResponse,
  BuilderCompanyInfoResponse,
  BuilderCompanyInfoUpdateRequest,
  BuilderDropdownResponseV2,
  EmailSubscriptionResponse,
  ExternalBuilderResponse,
  ExternalBuildersRequest,
  ForbiddenResponse,
  MobileLandingResponse,
  SeedBuilderRequest,
  SeedBuilderResponse,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `user-bearer`


**Authentication**: `auth0` | `LegacyBearer`


**Policy**: `ExternalUser`


**Stability Level**: `stable`
 * @summary Get information about the Builder the account is currently associated with.
 */
export const buildersGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ExternalBuilderResponse>(
    { url: `/apix/v2/Builders`, method: "GET", signal },
    options,
  );
};

export const getBuildersGetV2QueryKey = () => {
  return [`/apix/v2/Builders`] as const;
};

export const getBuildersGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof buildersGetV2>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof buildersGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBuildersGetV2QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof buildersGetV2>>> = ({
    signal,
  }) => buildersGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof buildersGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BuildersGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof buildersGetV2>>
>;
export type BuildersGetV2QueryError = ErrorType<void>;

/**
 * @summary Get information about the Builder the account is currently associated with.
 */

export function useBuildersGetV2<
  TData = Awaited<ReturnType<typeof buildersGetV2>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof buildersGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBuildersGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `machine-to-machine-bearer`


**Authentication**: `auth0`


**Policy**: `ExternalService`


**Stability Level**: `stable`
 */
export const buildersPostV2 = (
  externalBuildersRequest: BodyType<ExternalBuildersRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ExternalBuilderResponse[]>(
    {
      url: `/apix/v2/Builders`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: externalBuildersRequest,
      signal,
    },
    options,
  );
};

export const getBuildersPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof buildersPostV2>>,
    TError,
    { data: BodyType<ExternalBuildersRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof buildersPostV2>>,
  TError,
  { data: BodyType<ExternalBuildersRequest> },
  TContext
> => {
  const mutationKey = ["buildersPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof buildersPostV2>>,
    { data: BodyType<ExternalBuildersRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return buildersPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BuildersPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof buildersPostV2>>
>;
export type BuildersPostV2MutationBody = BodyType<ExternalBuildersRequest>;
export type BuildersPostV2MutationError = ErrorType<unknown>;

export const useBuildersPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof buildersPostV2>>,
    TError,
    { data: BodyType<ExternalBuildersRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof buildersPostV2>>,
  TError,
  { data: BodyType<ExternalBuildersRequest> },
  TContext
> => {
  const mutationOptions = getBuildersPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `machine-to-machine-bearer`


**Authentication**: `auth0`


**Policy**: `ExternalService`


**Stability Level**: `stable`
 * @summary Get information about a specified builder.
 */
export const buildersByBuilderIdGetV2 = (
  builderId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ExternalBuilderResponse>(
    { url: `/apix/v2/Builders/${builderId}`, method: "GET", signal },
    options,
  );
};

export const getBuildersByBuilderIdGetV2QueryKey = (builderId?: string) => {
  return [`/apix/v2/Builders/${builderId}`] as const;
};

export const getBuildersByBuilderIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof buildersByBuilderIdGetV2>>,
  TError = ErrorType<void>,
>(
  builderId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof buildersByBuilderIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBuildersByBuilderIdGetV2QueryKey(builderId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof buildersByBuilderIdGetV2>>
  > = ({ signal }) =>
    buildersByBuilderIdGetV2(builderId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!builderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof buildersByBuilderIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BuildersByBuilderIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof buildersByBuilderIdGetV2>>
>;
export type BuildersByBuilderIdGetV2QueryError = ErrorType<void>;

/**
 * @summary Get information about a specified builder.
 */

export function useBuildersByBuilderIdGetV2<
  TData = Awaited<ReturnType<typeof buildersByBuilderIdGetV2>>,
  TError = ErrorType<void>,
>(
  builderId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof buildersByBuilderIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBuildersByBuilderIdGetV2QueryOptions(
    builderId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `stable` 

 **Sunset Date**: 2026-02-02 - To be removed if we refactor the Lead Email Unsubscribe flow
 * @deprecated
 * @summary Gets the external builder info by encrypted id.
 */
export const buildersInfoByEncryptedIdGetV2 = (
  encryptedId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<EmailSubscriptionResponse>(
    { url: `/apix/v2/Builders/${encryptedId}/info`, method: "GET", signal },
    options,
  );
};

export const getBuildersInfoByEncryptedIdGetV2QueryKey = (
  encryptedId?: string,
) => {
  return [`/apix/v2/Builders/${encryptedId}/info`] as const;
};

export const getBuildersInfoByEncryptedIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof buildersInfoByEncryptedIdGetV2>>,
  TError = ErrorType<void>,
>(
  encryptedId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof buildersInfoByEncryptedIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBuildersInfoByEncryptedIdGetV2QueryKey(encryptedId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof buildersInfoByEncryptedIdGetV2>>
  > = ({ signal }) =>
    buildersInfoByEncryptedIdGetV2(encryptedId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!encryptedId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof buildersInfoByEncryptedIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BuildersInfoByEncryptedIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof buildersInfoByEncryptedIdGetV2>>
>;
export type BuildersInfoByEncryptedIdGetV2QueryError = ErrorType<void>;

/**
 * @deprecated
 * @summary Gets the external builder info by encrypted id.
 */

export function useBuildersInfoByEncryptedIdGetV2<
  TData = Awaited<ReturnType<typeof buildersInfoByEncryptedIdGetV2>>,
  TError = ErrorType<void>,
>(
  encryptedId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof buildersInfoByEncryptedIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBuildersInfoByEncryptedIdGetV2QueryOptions(
    encryptedId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `draft`
 * @summary Gets mobile landing page information by encrypted builder id.
 */
export const buildersMobileLandingByEncryptedIdGetV2 = (
  encryptedId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<MobileLandingResponse>(
    {
      url: `/apix/v2/Builders/${encryptedId}/mobile-landing`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getBuildersMobileLandingByEncryptedIdGetV2QueryKey = (
  encryptedId?: string,
) => {
  return [`/apix/v2/Builders/${encryptedId}/mobile-landing`] as const;
};

export const getBuildersMobileLandingByEncryptedIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof buildersMobileLandingByEncryptedIdGetV2>>,
  TError = ErrorType<void>,
>(
  encryptedId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof buildersMobileLandingByEncryptedIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBuildersMobileLandingByEncryptedIdGetV2QueryKey(encryptedId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof buildersMobileLandingByEncryptedIdGetV2>>
  > = ({ signal }) =>
    buildersMobileLandingByEncryptedIdGetV2(
      encryptedId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!encryptedId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof buildersMobileLandingByEncryptedIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BuildersMobileLandingByEncryptedIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof buildersMobileLandingByEncryptedIdGetV2>>
>;
export type BuildersMobileLandingByEncryptedIdGetV2QueryError = ErrorType<void>;

/**
 * @summary Gets mobile landing page information by encrypted builder id.
 */

export function useBuildersMobileLandingByEncryptedIdGetV2<
  TData = Awaited<ReturnType<typeof buildersMobileLandingByEncryptedIdGetV2>>,
  TError = ErrorType<void>,
>(
  encryptedId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof buildersMobileLandingByEncryptedIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBuildersMobileLandingByEncryptedIdGetV2QueryOptions(
    encryptedId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `machine-to-machine-bearer`


**Authentication**: `auth0`


**Policy**: `Testing`


**Stability Level**: `stable`
 * @summary Seeds a builder with a full entity graph for integration testing.
Creates or recovers a builder by name, including role, login, credentials,
cost codes, and subscription cache. Supports optional accounting and
online payment account creation.
 */
export const testingBuildersSeedPostV2 = (
  seedBuilderRequest: BodyType<SeedBuilderRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SeedBuilderResponse>(
    {
      url: `/apix/v2/testing/Builders/seed`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: seedBuilderRequest,
      signal,
    },
    options,
  );
};

export const getTestingBuildersSeedPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testingBuildersSeedPostV2>>,
    TError,
    { data: BodyType<SeedBuilderRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testingBuildersSeedPostV2>>,
  TError,
  { data: BodyType<SeedBuilderRequest> },
  TContext
> => {
  const mutationKey = ["testingBuildersSeedPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testingBuildersSeedPostV2>>,
    { data: BodyType<SeedBuilderRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return testingBuildersSeedPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestingBuildersSeedPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof testingBuildersSeedPostV2>>
>;
export type TestingBuildersSeedPostV2MutationBody =
  BodyType<SeedBuilderRequest>;
export type TestingBuildersSeedPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Seeds a builder with a full entity graph for integration testing.
Creates or recovers a builder by name, including role, login, credentials,
cost codes, and subscription cache. Supports optional accounting and
online payment account creation.
 */
export const useTestingBuildersSeedPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testingBuildersSeedPostV2>>,
    TError,
    { data: BodyType<SeedBuilderRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testingBuildersSeedPostV2>>,
  TError,
  { data: BodyType<SeedBuilderRequest> },
  TContext
> => {
  const mutationOptions = getTestingBuildersSeedPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `machine-to-machine-bearer`


**Authentication**: `auth0`


**Policy**: `Testing`


**Stability Level**: `stable`
 * @summary Activates a seeded builder by linking the caller's Auth0 identity to the specified GlobalUser.
Used by E2E tests in place of FinalizeActivation — bypasses the invitation flow
and directly writes the BTUsers row and activation fields on GlobalUsers.
Idempotent: if the GlobalUser is already activated with this identity, returns existing IDs.
 */
export const testingBuildersActivatePostV2 = (
  activateSeededBuilderRequest: BodyType<ActivateSeededBuilderRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ActivateSeededBuilderResponse>(
    {
      url: `/apix/v2/testing/Builders/activate`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: activateSeededBuilderRequest,
      signal,
    },
    options,
  );
};

export const getTestingBuildersActivatePostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testingBuildersActivatePostV2>>,
    TError,
    { data: BodyType<ActivateSeededBuilderRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testingBuildersActivatePostV2>>,
  TError,
  { data: BodyType<ActivateSeededBuilderRequest> },
  TContext
> => {
  const mutationKey = ["testingBuildersActivatePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testingBuildersActivatePostV2>>,
    { data: BodyType<ActivateSeededBuilderRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return testingBuildersActivatePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestingBuildersActivatePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof testingBuildersActivatePostV2>>
>;
export type TestingBuildersActivatePostV2MutationBody =
  BodyType<ActivateSeededBuilderRequest>;
export type TestingBuildersActivatePostV2MutationError = ErrorType<unknown>;

/**
 * @summary Activates a seeded builder by linking the caller's Auth0 identity to the specified GlobalUser.
Used by E2E tests in place of FinalizeActivation — bypasses the invitation flow
and directly writes the BTUsers row and activation fields on GlobalUsers.
Idempotent: if the GlobalUser is already activated with this identity, returns existing IDs.
 */
export const useTestingBuildersActivatePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testingBuildersActivatePostV2>>,
    TError,
    { data: BodyType<ActivateSeededBuilderRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testingBuildersActivatePostV2>>,
  TError,
  { data: BodyType<ActivateSeededBuilderRequest> },
  TContext
> => {
  const mutationOptions =
    getTestingBuildersActivatePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 * @summary Gets the list of builders for a builder select component
 */
export const adminBuildersSearchGetV2 = (
  params?: AdminBuildersSearchGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BuilderDropdownResponseV2>(
    { url: `/apix/v2/admin/Builders/search`, method: "GET", params, signal },
    options,
  );
};

export const getAdminBuildersSearchGetV2QueryKey = (
  params?: AdminBuildersSearchGetV2Params,
) => {
  return [
    `/apix/v2/admin/Builders/search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminBuildersSearchGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminBuildersSearchGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(
  params?: AdminBuildersSearchGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminBuildersSearchGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminBuildersSearchGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminBuildersSearchGetV2>>
  > = ({ signal }) => adminBuildersSearchGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminBuildersSearchGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminBuildersSearchGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminBuildersSearchGetV2>>
>;
export type AdminBuildersSearchGetV2QueryError = ErrorType<ForbiddenResponse>;

/**
 * @summary Gets the list of builders for a builder select component
 */

export function useAdminBuildersSearchGetV2<
  TData = Awaited<ReturnType<typeof adminBuildersSearchGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(
  params?: AdminBuildersSearchGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminBuildersSearchGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminBuildersSearchGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 */
export const adminBuildersCompanyInfoByBuilderIdGetV2 = (
  builderId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BuilderCompanyInfoResponse>(
    {
      url: `/apix/v2/admin/Builders/${builderId}/company-info`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getAdminBuildersCompanyInfoByBuilderIdGetV2QueryKey = (
  builderId?: number,
) => {
  return [`/apix/v2/admin/Builders/${builderId}/company-info`] as const;
};

export const getAdminBuildersCompanyInfoByBuilderIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminBuildersCompanyInfoByBuilderIdGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(
  builderId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminBuildersCompanyInfoByBuilderIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAdminBuildersCompanyInfoByBuilderIdGetV2QueryKey(builderId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminBuildersCompanyInfoByBuilderIdGetV2>>
  > = ({ signal }) =>
    adminBuildersCompanyInfoByBuilderIdGetV2(builderId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!builderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminBuildersCompanyInfoByBuilderIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminBuildersCompanyInfoByBuilderIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminBuildersCompanyInfoByBuilderIdGetV2>>
>;
export type AdminBuildersCompanyInfoByBuilderIdGetV2QueryError =
  ErrorType<ForbiddenResponse>;

export function useAdminBuildersCompanyInfoByBuilderIdGetV2<
  TData = Awaited<ReturnType<typeof adminBuildersCompanyInfoByBuilderIdGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(
  builderId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminBuildersCompanyInfoByBuilderIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminBuildersCompanyInfoByBuilderIdGetV2QueryOptions(
    builderId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 */
export const adminBuildersCompanyInfoByBuilderIdPutV2 = (
  builderId: number,
  builderCompanyInfoUpdateRequest: BodyType<BuilderCompanyInfoUpdateRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/admin/Builders/${builderId}/company-info`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: builderCompanyInfoUpdateRequest,
    },
    options,
  );
};

export const getAdminBuildersCompanyInfoByBuilderIdPutV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminBuildersCompanyInfoByBuilderIdPutV2>>,
    TError,
    { builderId: number; data: BodyType<BuilderCompanyInfoUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminBuildersCompanyInfoByBuilderIdPutV2>>,
  TError,
  { builderId: number; data: BodyType<BuilderCompanyInfoUpdateRequest> },
  TContext
> => {
  const mutationKey = ["adminBuildersCompanyInfoByBuilderIdPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminBuildersCompanyInfoByBuilderIdPutV2>>,
    { builderId: number; data: BodyType<BuilderCompanyInfoUpdateRequest> }
  > = (props) => {
    const { builderId, data } = props ?? {};

    return adminBuildersCompanyInfoByBuilderIdPutV2(
      builderId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminBuildersCompanyInfoByBuilderIdPutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof adminBuildersCompanyInfoByBuilderIdPutV2>>
  >;
export type AdminBuildersCompanyInfoByBuilderIdPutV2MutationBody =
  BodyType<BuilderCompanyInfoUpdateRequest>;
export type AdminBuildersCompanyInfoByBuilderIdPutV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

export const useAdminBuildersCompanyInfoByBuilderIdPutV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminBuildersCompanyInfoByBuilderIdPutV2>>,
    TError,
    { builderId: number; data: BodyType<BuilderCompanyInfoUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminBuildersCompanyInfoByBuilderIdPutV2>>,
  TError,
  { builderId: number; data: BodyType<BuilderCompanyInfoUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getAdminBuildersCompanyInfoByBuilderIdPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 */
export const adminBuildersResetNotificationsByBuilderIdPostV2 = (
  builderId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/admin/Builders/${builderId}/reset-notifications`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getAdminBuildersResetNotificationsByBuilderIdPostV2MutationOptions =
  <TError = ErrorType<ForbiddenResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof adminBuildersResetNotificationsByBuilderIdPostV2>
      >,
      TError,
      { builderId: number },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof adminBuildersResetNotificationsByBuilderIdPostV2>
    >,
    TError,
    { builderId: number },
    TContext
  > => {
    const mutationKey = ["adminBuildersResetNotificationsByBuilderIdPostV2"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof adminBuildersResetNotificationsByBuilderIdPostV2>
      >,
      { builderId: number }
    > = (props) => {
      const { builderId } = props ?? {};

      return adminBuildersResetNotificationsByBuilderIdPostV2(
        builderId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AdminBuildersResetNotificationsByBuilderIdPostV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof adminBuildersResetNotificationsByBuilderIdPostV2>>
  >;

export type AdminBuildersResetNotificationsByBuilderIdPostV2MutationError =
  ErrorType<ForbiddenResponse>;

export const useAdminBuildersResetNotificationsByBuilderIdPostV2 = <
  TError = ErrorType<ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof adminBuildersResetNotificationsByBuilderIdPostV2>
    >,
    TError,
    { builderId: number },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminBuildersResetNotificationsByBuilderIdPostV2>>,
  TError,
  { builderId: number },
  TContext
> => {
  const mutationOptions =
    getAdminBuildersResetNotificationsByBuilderIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
